import { Brain, BookOpen, Music, Wind, ArrowRight } from "lucide-react";
import { FEATURES } from "@/data";
import { Reveal } from "@/components/Reveal";

const ICONS = { Brain, BookOpen, Music, Wind };

export const Features = () => (
  <section className="py-20 bg-brand-cream">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
      {FEATURES.map((f, i) => {
        const Icon = ICONS[f.icon];
        return (
          <Reveal key={f.title} delay={i * 0.08}>
            <div className="h-full">
              <span className="text-brand-gold"><Icon size={30} strokeWidth={1.4} /></span>
              <h4 className="font-display text-xl text-brand-forest mt-4 leading-snug">{f.title}</h4>
              <p className="font-body text-sm text-brand-inkSoft mt-3 leading-relaxed">{f.text}</p>
              <a href={f.anchor} className="inline-flex items-center gap-1.5 mt-4 text-brand-sage text-sm font-body hover:text-brand-forest transition-colors">
                Meer informatie <ArrowRight size={14} />
              </a>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);
